import { useCallback, useEffect, useState } from 'react';
import { debounceFunction } from '../../../utility/utility';
import { useNotifications } from '../../../hooks/useNotifications';
import { ApplicationsService } from '../../../services/applicationsService';

export const useApp = ({ idApp, getApplicationForm = ApplicationsService.getFormById }) => {
  const [dataForm, setDataForm] = useState(null);
  const [formTitle, setFormTitle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { showErrorNotification } = useNotifications();

  const getMobileForm = useCallback(
    debounceFunction(async () => {
      if (!idApp) return;
      setIsLoading(true);
      try {
        const { application } = await getApplicationForm(idApp);
        setDataForm(application?.form);
        setFormTitle(application?.name)
      } catch (error) {
        console.error(error);
        showErrorNotification({
          title: 'error',
          description: 'errorRetrievingRecord',
        });
      } finally {
        setIsLoading(false);
      }
    }, 200),
    [idApp],
  );

  useEffect(() => {
    getMobileForm();
  }, [getMobileForm]);

  return { dataForm, isLoading, formTitle };
};
